<template>
    <b-card no-body>

        <b-modal id="upload" title="Takograf Verilerini Yükle" scrollable no-close-on-esc no-close-on-backdrop>
            <upload-tachograph-vehicle v-model="tachograph"></upload-tachograph-vehicle>
            <template #modal-footer><v-executer :disabled="tachograph.Files.length == 0" :loading="loading" :text="loading ?'Dosyalar işleniyor... Bu işlem uzun sürebilir.' :'Yükle'" :action="upload"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    with-items
                    :items="items"
                    name="tachograph-vehicle-operations"
                    :excel-callback="getExcel"
                    pagination="client"
                    :settings="false"
                    search
                    :fields="fields">
                        <template #additional-thead>
                            <tr v-if="c_hasTotal">
                                <th></th>
                                <th class="v-table-column-sticky align-middle">
                                    {{c_month}} {{showingYear}}
                                </th>
                                <th class="align-middle text-center">
                                    <span class="font-weight-bolder text-success"><short-text text="Aylık Toplam Sürüş Zamanı"></short-text></span><br/>
                                    {{$safe(monthlyTotal,'MonthlyTotalDrivingTime')}}
                                </th>
                                <th class="align-middle text-center">
                                    <span class="font-weight-bolder text-primary"><short-text text="Aylık Toplam Rölanti Zamanı"></short-text></span><br/>
                                    {{$safe(monthlyTotal,'MonthlyTotalWorkingTime')}}
                                </th>
                                <th class="align-middle text-center">
                                    <span class="font-weight-bolder text-secondary"><short-text text="Aylık Toplam Gece Çalışma Zamanı"></short-text></span><br/>
                                    {{$safe(monthlyTotal,'MonthlyTotalNightWorkingTime')}}   
                                </th>
                                <th class="align-middle text-center">
                                    <span class="font-weight-bolder text-warning"><short-text text="Aylık Toplam Çalışılabilir Zaman"></short-text></span><br/>
                                    {{$safe(monthlyTotal,'MonthlyTotalAvailableTime')}}
                                </th>
                                <th class="align-middle text-center">
                                    <span class="font-weight-bolder text-danger"><short-text text="Aylık Toplam Dinlenme Zamanı"></short-text></span><br/>
                                    {{$safe(monthlyTotal,'MonthlyTotalRestTime')}}
                                </th>
                                <template v-for="(total,index) in totals">
                                    <td class="text-center" :key="'DTDT'+index">
                                        <span class="font-weight-bolder text-success"><short-text text="Günlük Toplam Sürüş Zamanı"></short-text></span><br/>
                                        {{total.DailyTotalDrivingTime || '-'}}
                                    </td>
                                    <td class="text-center" :key="'DTWT'+index">
                                        <span class="font-weight-bolder text-primary"><short-text text="Günlük Toplam Rölanti Zamanı"></short-text></span><br/>
                                        {{total.DailyTotalWorkingTime || '-'}}
                                    </td>
                                    <td class="text-center" :key="'DTNWT'+index">
                                        <span class="font-weight-bolder text-secondary"><short-text text="Günlük Toplam Gece Çalışma Zamanı"></short-text></span><br/>
                                        {{total.DailyNightWorkingTime || '-'}}
                                    </td>
                                    <td class="text-center" :key="'DTAT'+index">
                                        <span class="font-weight-bolder text-warning"><short-text text="Günlük Toplam Çalışılabilir Zaman"></short-text></span><br/>
                                        {{total.DailyTotalAvailableTime || '-'}}
                                    </td>
                                    <td class="text-center" :key="'DTRT'+index">
                                        <span class="font-weight-bolder text-danger"><short-text text="Günlük Toplam Dinlenme Zamanı"></short-text></span><br/>
                                        {{total.DailyTotalRestTime || '-'}}
                                    </td>
                                </template>
                            </tr>
                            <tr v-if="c_hasTotal">
                                <th colspan="1500"></th>
                            </tr>
                        </template>
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <select class="form-control" v-model="month">
                                        <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <select class="form-control" v-model="year">
                                        <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                                    </select>
                                </div>
                                <div class="col-md-auto mb-1 mb-md-0">
                                    <button class="btn btn-success" v-on:click="getTachograph">
                                        Sorgula
                                    </button>
                                </div>
                                <div class="col-md-auto">
                                    <button class="btn btn-primary w-100" v-on:click="openUplaoder">
                                        Takograf Verilerini Yükle
                                    </button>
                                </div>
                                <div class="col-md-auto">
                                    <b-dropdown variant="dark">
                                        <template #button-content>
                                            <feather-icon icon="FilterIcon" class="mr-50"></feather-icon>
                                            Filtrele
                                        </template>
                                        <div class="pr-50 pl-50">
                                            <div class="p-25" v-for="f in filters" :key="f.key">
                                                <b-form-checkbox :disabled="f.value == true && c_onlyOneFilterDisabled" v-on:change="filterData(f.key,$event)" class="text-nowrap" v-model="f.value"><span class="font-weight-bolder" :class="f.variant">{{f.key}}</span> - {{f.text}}</b-form-checkbox>
                                            </div>
                                        </div>
                                    </b-dropdown>
                                </div>
                            </div>
                        </template>
                        <template #information>
                            <b>'-' (tire)</b> ifadesi o gün için veri olmadığı anlamına gelir.
                        </template>
                </v-table>  
    </b-card>
</template>

<script>
import {BCard,BDropdown,BFormCheckbox} from 'bootstrap-vue'
import moment from 'moment'
import EmployeeOperationsApi from '@/api/employee-operations' 
import UploadTachographVehicle from './components/UploadTachographVehicle'
import Additional from '@/utilities/additional'
import ShortText from '@/components/ShortText.vue'
export default {
    components:{
        BCard,
        UploadTachographVehicle,
        BDropdown,
        BFormCheckbox,
        ShortText
    },
    data(){
        return{
            month:null,
            showingMonth:null,
            years:[],
            year:null,
            showingYear:null,
            items:[],
            totals:[],
            monthlyTotal:{
                MonthlyTotalAvailableTime:null,
                MonthlyTotalDrivingTime:null,
                MonthlyTotalNightWorkingTime:null,
                MonthlyTotalRestTime:null,
                MonthlyTotalWorkingTime:null
            },
            fields:[
                { name:"Sıra", key:"Order", tdClass:"text-center font-weight-bolder"},
                { name:"Plaka",tdClass:'text-nowrap',key:"VehiclePlate",sticky:true},
                { name:"TSZ",tdClass:'text-nowrap font-weight-bolder border-right',key:"MonthlyTotalDrivingTime", tooltip:'Toplam Sürüş Zamanı'},
                { name:"TRZ",tdClass:'text-nowrap font-weight-bolder border-right',key:"MonthlyTotalWorkingTime", tooltip:'Toplam Rölanti Zamanı'},
                { name:"TGÇZ",tdClass:'text-nowrap font-weight-bolder border-right',key:"MonthlyTotalNightWorkingTime", tooltip:'Toplam Gece Çalışma Zamanı'},
                { name:"TÇZ",tdClass:'text-nowrap font-weight-bolder border-right',key:"MonthlyTotalAvailableTime", tooltip:'Toplam Çalışılabilir Zamanı'},
                { name:"TDZ",tdClass:'text-nowrap font-weight-bolder border-right',key:"MonthlyTotalRestTime", tooltip:'Toplam Dinlenme Zamanı'},
            ],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            filters:[
                {key:"SZ",variant:"text-success",text:"Sürüş Zamanı",value:true},
                {key:"RZ",variant:"text-primary",text:"Rolanti Zamanı",value:true},
                {key:"GÇZ",variant:"text-secondary",text:"Gece Çalışma Zamanı",value:true},
                {key:"ÇZ",variant:"text-warning",text:"Çalışılabilir Zaman",value:true},
                {key:"DZ",variant:"text-danger",text:"Dinlenme Zamanı",value:true},
            ],
            loading:false,
            tachograph:{
                Files:[]
            }
        }
    },
    mounted(){
        this.getCurrentYear()
        this.configureYears()
        this.getCurrentMonth()
        this.configureFields(Date.now())
        this.getTachograph()
    },
    methods:{
        configureYears(){
            let years = []
            let year = 2015
            while(year <= this.year){
                years.push(year)
                year ++
            }
            this.years = years
        },
        getCurrentYear(){
            this.year = moment().format('YYYY')
        },
        getCurrentMonth(){
            let current = moment().month() + 1
            this.month = this.months.find(m=>m.index == current)?.index || 0
        },
        configureFields(date){
            this.fields = this.fields.filter(f=> !f.date)
            Array.from(Array(moment(date).daysInMonth()).keys()).forEach((d,index)=>{
                let _date = moment(date).startOf("month").add(d,'days')
                let _dateForObject = _date.format('YYYY-MM-DD')
                let _dateForName = _date.format('DD.MM.YYYY')
                this.fields.push(
                    { name: _dateForName,
                    date:true,
                        children:[
                            { name:"SZ", thClass:"text-success", key:'Data.'+_dateForObject+'.DrivingTime',tooltip:"Sürüş Zamanı"},
                            { name:"RZ", thClass:"text-primary", key:'Data.'+_dateForObject+'.WorkingTime',tooltip:"Rolanti Zamanı"},
                            { name:"GÇZ", thClass:"text-secondary", key:'Data.'+_dateForObject+'.NightWorkingTime',tooltip:"Gece Çalışma Zamanı"},
                            { name:"ÇZ", thClass:"text-warning", key:'Data.'+_dateForObject+'.AvailableTime',tooltip:"Çalışılabilir Zaman"},
                            { name:"DZ", tdClass:"border-right", thClass:"text-danger",key:'Data.'+_dateForObject+'.RestTime',tooltip:"Dinlenme Zamanı"}
                        ]
                    },
                )
            })
        },
        configureData(data){
            data.forEach(d=>{
                let currentDays = d.Data.reduce((object,dt)=>{ 
                    let days = Object.keys(dt).filter(k=> k != 'DriverFullName') 
                    days.forEach(day=>{
                        Object.assign(object,{[day]:dt[day]})
                    })
                    return object
                },{})
                d.Data = currentDays
            })
            return data
        },
        configureTotalData(data){
            let resultData = []
            let date = moment(this.year+'-'+this.month,'YYYY-MM')
            Array.from(Array(moment(date).daysInMonth()).keys()).forEach((d,index)=>{
                let _date = moment(date).startOf("month").add(d,'days').format('DD.MM.YYYY')
                let item = data.find(d=>d.Date == _date)
                let resultItem = { DailyTotalAvailableTime:null, DailyTotalDrivingTime:null, DailyTotalRestTime:null, DailyTotalWorkingTime:null, DailyNightWorkingTime:null, Date:_date }
                if(item){
                    resultItem.DailyTotalAvailableTime = item.DailyTotalAvailableTime
                    resultItem.DailyTotalDrivingTime = item.DailyTotalDrivingTime
                    resultItem.DailyTotalRestTime = item.DailyTotalRestTime
                    resultItem.DailyTotalWorkingTime = item.DailyTotalWorkingTime
                    resultItem.DailyNightWorkingTime = item.DailyNightWorkingTime
                }
                resultData.push(resultItem)
            })
            return resultData
        },
        getTachograph(){
            this.$refs.table.setLoading(true)
            EmployeeOperationsApi.Tachograph.VehicleMonthlyDrivingTime(this.month,this.year).then(res=>{
                let date = moment(this.year+'-'+this.month,'YYYY-MM')
                this.configureFields(date)
                this.showingMonth = this.month
                this.showingYear = this.year
                this.items = this.configureData(res.data.resData)
                this.totals = this.configureTotalData(res.data.dailyData)
                this.monthlyTotal = res.data.monthlyTotalSumByActivityType[0]
                this.$refs.table.setLoading(false)
            })
        },
        clearForm(){
            this.tachograph.Files = []
        },
        openUplaoder(){
            this.clearForm()
            this.$showModal("upload")
        },
        async upload(){
            this.loading = true
            let formData = await Additional.ToFormData(this.tachograph)
            EmployeeOperationsApi.Tachograph.VehicleUploadFile(formData).then(res=>{
                this.$result(res)
                this.loading = false
                this.$hideModal("upload")
                this.getTachograph()
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        getExcel(){
            this.$refs.table.setExcelLoading(true)
            EmployeeOperationsApi.Tachograph.ExcelVehicleExport(this.month,this.year).then(res=>{
                Additional.DownloadFile(res.data,'Takograf.xlsx')
                this.$refs.table.setExcelLoading(false)
            }).catch(err=>{
                this.$result(null,err)
                this.$refs.table.setExcelLoading(false)
            })
        },
        filterData(key,e){
            this.$refs.table.dataVisibility("name",key,e)
        },
    },
    computed:{
        c_onlyOneFilterDisabled(){
            return this.filters.filter(f=> f.value == true). length == 1 ? true : false
        },
        c_month(){
            return this.months.find(m=> m.index == this.showingMonth)?.name || ""
        },
        c_hasTotal(){
            return this.totals.filter(t =>
                t.DailyNightWorkingTime != null ||
                t.DailyTotalAvailableTime != null ||
                t.DailyTotalDrivingTime != null ||
                t.DailyTotalRestTime != null ||
                t.DailyTotalWorkingTime != null
            ).length > 0 ? true : false
        }
    }
}
</script>

<style lang="scss">
</style>